<template>
    <div class="c-alert-bar p-3" :class="'u-'+alertType">
        <slot name="message"></slot>
    </div>
</template>

<script>
export default {
    props:{
        alertType:{
            type: String,
            default: 'warning',
            required: false
        },
    }

}
</script>

<style scoped>
    .c-alert-bar{
        font-family: 'Montserrat', sans-serif;
        min-height: 64px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .c-alert-bar p{
        margin: 0;
    }
    .u-info{
        background-color: var(--cyan);
    }
    .u-danger{
        background-color: #FF4A5133;
    }
    .u-warning{
        background-color: var(--color__warning);
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/DashboardAlertBar.vue